import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { mapVisibilityUpdated } from '../redux/actions/map';
import { getSettings } from '../util/getSettings';

import Toggle from './shared/toggle';

function ShowMapToggle() {
    const mapState = useSelector((state) => state.map);
    const labels = getSettings(['century', 'labels'], true);
    const dispatch = useDispatch();

    return (
        <Toggle
            toggleText={labels.showMapLabel}
            checked={mapState.visible}
            onChange={val => dispatch(mapVisibilityUpdated(val))}
        />
    )
}

export default ShowMapToggle